import { createAction } from 'redux-actions';

export const postDayxPublicRequest = createAction('POST_DAYX_PUBLIC_REQUEST');
export const postDayxPublicSuccess = createAction('POST_DAYX_PUBLIC_SUCCESS');
export const postDayxPublicFail = createAction('POST_DAYX_PUBLIC_FAIL');

export const dayxStatusChanged = createAction('DAYX_STATUS_CHANGED');
